<!-- 商品管理 V2 详情 - 采购商品链接历史弹窗 -->
<template>
  <el-dialog
    title="采购商品链接"
    :visible.sync="visible"
    width="900px"
    append-to-body
    custom-class="purchase-link-dialog"
  >
    <div v-loading="loading" class="purchase-link-content">
      <div class="history-table">
        <div class="history-head history-grid">
          <div>商品链接</div>
          <div>商品图片</div>
          <div>工厂</div>
          <div>历史使用次数</div>
          <div>链接当前状态</div>
        </div>
        <div v-for="(item, index) in list" :key="item.link || index" class="history-row history-grid">
          <div><a :href="item.link" target="_blank" rel="noopener noreferrer">{{ item.link }}</a></div>
          <div><el-image v-if="item.pic" :src="item.pic" fit="cover" :preview-src-list="[item.pic]" /></div>
          <div>{{ item.factory || '-' }}</div>
          <div>{{ item.use_count == null ? 0 : item.use_count }}</div>
          <div :class="{ invalid: Number(item.link_status) !== 1 }">{{ item.link_status_name || '-' }}</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
/**
 * 详情页「采购商品链接」按钮
 * 展示该商品历史采购链接及使用次数、状态
 */
export default {
  name: 'PurchaseLinkDialog',
  data() {
    return {
      visible: false,
      loading: false,
      detail: {},
      list: []
    }
  },
  methods: {
    // 拉取 historyPurchaseLinks 并打开弹窗
    open(detail) {
      this.detail = detail
      this.visible = true
      this.loading = true
      this.$api.productManagementApi.historyPurchaseLinks({
        user_id: detail.user_id,
        sys_code: detail.sys_code
      }).then(res => {
        this.list = Array.isArray(res.data) ? res.data : ((res.data && res.data.list) || [])
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.purchase-link-content { min-height: 180px; }

.history-table { overflow: hidden; border: 1px solid #dcdfe6; border-radius: 4px; }
.history-grid { display: grid; grid-template-columns: 2.2fr 130px 1.2fr 130px 140px; }
.history-head { min-height: 46px; background: #edeff4; font-weight: 700; }
.history-row { min-height: 112px; border-top: 1px solid #dcdfe6; background: #fff; }
.history-grid > div { display: flex; align-items: center; justify-content: center; min-width: 0; padding: 12px; box-sizing: border-box; }
.history-row a { overflow: hidden; color: #2c96e7; line-height: 20px; text-overflow: ellipsis; word-break: break-all; }
.history-row .el-image { width: 70px; height: 70px; border-radius: 4px; }
.invalid { color: #e05a61; font-weight: 700; }
</style>

<style lang="scss">
.purchase-link-dialog .el-dialog__body { padding-top: 12px; }
</style>
